import React, { useState } from 'react';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';
import './AttractionCard.css';

const AttractionCard = ({ id, imageSrc, title, badgeText, discountText, description, onToggleLike, liked }) => {
  const [hovered, setHovered] = useState(false);

  const handleToggleLike = () => {
    if (onToggleLike) {
      onToggleLike(id); 
    }
  };

  return (
    <div 
      className="attraction-card" 
      onMouseEnter={() => setHovered(true)} 
      onMouseLeave={() => setHovered(false)}
    >
      <img src={imageSrc} alt={title} className="attraction-card-image" />
      {badgeText && <div className="badge">{badgeText}</div>}
      <div className={`attraction-card-overlay ${hovered ? 'hovered' : ''}`}>
        <div className="attraction-card-title">{title}</div>
        {hovered && <div className="attraction-card-description">{description}</div>}
      </div>
      <div className="like-icon" onClick={handleToggleLike}>
        {liked ? <HeartFilled /> : <HeartOutlined />}
      </div>
    </div>
  );
};

export default AttractionCard;
